import type { Condicao } from '@peniel/shared'
import { BADGE_CONDICAO } from '@peniel/shared'

import { Badge } from '@/shared/ui/Badge.jsx'

/**
 * Selos sobre a foto, exatamente como no protótipo:
 *  - nova : "NOVA" pill brand-500 no canto superior ESQUERDO
 *  - usada: "USADA" mini gray-800 à esquerda
 *  - vendida: acrescenta "VENDIDA" mini red-500 à DIREITA
 */
export function BadgeCondicao({
  condicao,
  variante,
}: {
  condicao: Condicao
  variante: 'nova' | 'usada'
}) {
  return (
    <Badge
      tom={variante === 'nova' ? 'marca' : 'escuro'}
      tamanho={variante === 'nova' ? 'pill' : 'mini'}
      className={variante === 'nova' ? 'absolute left-4 top-4 z-10' : 'absolute left-3 top-3 z-10'}
    >
      {BADGE_CONDICAO[condicao]}
    </Badge>
  )
}

export function BadgeVendida() {
  return (
    <Badge tom="vermelho" tamanho="mini" className="absolute right-3 top-3 z-10">
      VENDIDA
    </Badge>
  )
}
